module.exports = __webpack_public_path__ + "static/media/IMG_036.79e882f1.PNG";